import { ModalConfig, ModalType } from "../../../../../models/common/modal/modal-config";

export enum CountType {
  Form = 'Form',
  Task = 'Task',
  Reward = 'Reward',
  //  Loop = 'Loop',
  Patrol = 'Patrol'
}

export const START_SHIFT_GEOFENCE_RESPONSE_CODE = 'TIMESHEET ADD';

export const START_FORM_GEOFENCE_RESPONSE_CODE = 'FORM GET';

export const START_SHIFT_GEOFENCE_MODAL_CONSTANTS: ModalConfig = {
  type: ModalType.ALERT,
  title: 'Unable to Start Shift',
  message: "You're too far from your shift {area} to start this shift. Please move closer and try again or contact your system administrator.",
};

export const END_SHIFT_MODAL_CONSTANTS: ModalConfig = {
  type: ModalType.DELETE,
  title: 'End Shift',
  message: `Your shift length is less than business_setting_time min.
  If you want to end the shift then it will be automatically discarded.
  Are you Sure?`,
  buttons: {
    button1:  {
      text: 'End Shift',
    }
  }
};
